// Hooks
import useRouter from '../../hooks/useRouter';
import useTableControl from '../../hooks/useTableControl';

// Components
import { Button, Grid } from '@mui/material';
import Title from '../../components/shared/Title';
import TableComponent from '../../components/shared/table/TableComponent';
import Filters from '../../components/shared/Filters';
import DeleteModal from '../../components/shared/DeleteModal';

// Services
import { deleteBlog, getBlogPaginated } from '../../services/blog';

// Libraries
import moment from 'moment';

const BlogList = () => {
  const cacheName = 'blog';
  const {
    resetFilters,
    getDataWithFilters,
    valuesFilters,
    setValuesFilters,
    deleteData,
    showFilters,
    toggleFilters,
    handleDeleteItem,
    handleEditItem,
    handleCloseDeleteItem,
    ...tableControlProps
  } = useTableControl({
    getAllAnyWithFilters: getBlogPaginated,
    orderBy: 'Title',
    cacheName,
  });
  const { navigate } = useRouter();

  const renderDate = (date) => {
    if (!date || date === null) {
      return 'N/A';
    }
    return moment(date).format('DD/MM/YYYY');
  };

  const columns = [
    { id: 'Title', type: 'string', label: 'Title', isSortable: true },
    { id: 'Category', type: 'string', label: 'Category', isSortable: true },
    { id: 'IsFeatured', type: 'boolean', label: 'Is Featured', isSortable: true },
    { id: 'CreatedAt', type: 'custom', render: renderDate, label: 'Created At', isSortable: true },
    { id: 'UpdatedAt', type: 'custom', render: renderDate, label: 'Updated At', isSortable: true },
    { id: 'actions', type: 'actions' },
  ];

  const actions = [
    { type: 'edit', func: handleEditItem },
    { type: 'delete', func: handleDeleteItem, paramNeeded: 'all' },
  ];

  const filters = [
    { title: 'Title', name: 'Title', type: 'string', evaluator: 'lk', containerName: 'default' },
    {
      title: 'Category',
      name: 'Category',
      type: 'string',
      evaluator: 'lk',
      containerName: 'default',
    },
    { title: 'Is Featured', name: 'IsFeatured', type: 'boolean', evaluator: 'eq', containerName: 'default' },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <Title text1="Blog" text2="List" />
      </Grid>
      <Grid item xs={12} className="mb-5">
        <Button variant="contained" color="secondary" className="mr-3" size="small" onClick={() => navigate('add')}>
          Add new item
        </Button>
        <Button variant="outlined" color="primary" onClick={toggleFilters} size="small">
          {showFilters ? 'Hide' : 'Show'} filters
        </Button>
      </Grid>
      {showFilters && (
        <Grid item xs={12} md={3} className="md:pr-5 lg:mb-0 mb-5">
          <Filters
            filters={filters}
            resetFilters={resetFilters}
            sendFilters={getDataWithFilters}
            values={valuesFilters}
            setValues={setValuesFilters}
          />
        </Grid>
      )}
      <Grid item xs={12} md={showFilters ? 9 : 12}>
        <TableComponent {...tableControlProps} columns={columns} actions={actions} />
        <DeleteModal
          {...deleteData}
          handleCloseDeleteItem={handleCloseDeleteItem}
          deleteFunc={deleteBlog}
          resetFilters={resetFilters}
          cacheName={cacheName}
        />
      </Grid>
    </Grid>
  );
};

export default BlogList;
